import React,{useEffect} from "react";

import "./Iste.css";
import { Timeline, Listformat } from "../../components";
import { Underline, Backtotop,ContentCard} from "../../widgets";
import { istepdf, istelist,iste_stud_chapter } from "../../constants/iste";

const istelogo ="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/iste/istelogo.webp"


function Iste() {
  useEffect(() => {
    document.title = 'ACCET-ISTE';
  }, []);
  return (
    <div>
      <Backtotop />
      <div className="istewhole">
        <Underline heading="Indian Society For Technical Education" />
        <div className="isteabt">
          <div className="isteabttext">
            <p className="isteabttextp">
              The Indian Society for Technical Education (ISTE) is the leading
              National Professional non-profit making Society for the Technical
              Education System in our country with the motto of Career
              Development of teachers and Personality Development of Students
              and overall development of our Technical Education System. ISTE
              Students Chapter TN156 is an active technical club of ACCET open
              for all the years and having 823 student members this academic
              year. We have planned to have more than 320 members the next year.
              The events are conducted technically on the basis of preparing the
              students for placement and higher studies. ISTE has conducted
              events like general apps, technical apps, Group discussion,
              technical GD, technical quiz, presentations, and mock interviews.
              Apart from this, we would be having classes on our technical
              subjects. The events are conducted weekly. The club also provides
              awareness about the civil service exams and their competitive
              exams. ISTE Best students award is also offered to the students
              with good academic records by the ISTE every year to encourage the
              students to concentrate more on academics. Dr. C. UmaRani serves
              as the coordinator of ISTE for our college, providing valuable
              leadership and guidance. We also conducted a National Level Maths
              Competition-Srinivasa Ramanujan Mathematical Competition
              successfully. The club has conducted a National Level Symposium
              ACISTECH’16 under the banner of ISTE with the procurement of
              ACISTECH’15, which was held on 02.03.2016, about 96 students had
              participated from various colleges in Tamil Nadu. Events were
              conducted for the disciplines of EEE, ECE, CSE, CIVIL, and
              MECHANICAL.
            </p>
          </div>
          
          <div className="isteabtpic">
            <img className="isteabtpici" src={istelogo} alt="istelogo" />
          </div>
        </div>
        <div>
          <h3 className="iste-official-link">
  <a
    href="https://www.isteofacgcet.in/"
    target="_blank"
    rel="noopener noreferrer"
  >
    Official ISTE Website
  </a>
</h3>
        </div>

        <Underline heading="Objective" />
        <Listformat points={istelist} />

        <Underline heading="Annual Reports" />
        <div className="istepdfsec">
          <div className="istepdf">
            {istepdf.map((item) => (
              <Timeline
                key={item.id}
                head={item.head}
                house={item.house}
                pdf={item.pdf}
              />
            ))}
          </div>
          

        </div>
        <Underline heading="ISTE Student Chapter TN156" />
        <div className="iste_cards">
            {iste_stud_chapter.map((item)=><ContentCard key={item.id} heading={item.program} pdf={item.pdf}/>)}
        </div>
      </div>
    </div>
  );
}

export default Iste;
